import React from 'react';
import styled from 'styled-components';
import { Sponsors } from '../../data/constants';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
  z-index: 1;
  align-items: center;
`;

const Wrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 1550px;
  padding: 80px 0;
  gap: 12px;
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

export const Title = styled.div`
  font-size: 42px;
  text-align: center;
  font-weight: 600;
  color: ${({ theme }) => theme.text_primary};
  @media (max-width: 768px) {
    font-size: 32px;
  }
`;

export const Desc = styled.div`
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  color: ${({ theme }) => theme.text_secondary};
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

const SkillsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin-top: 30px;
  gap: 30px;
  justify-content: center;
`;


// 
// border: 0.1px solid #854ce6;
const Skill = styled.div`
  width: 100%;
  max-width: 500px;
  background: ${({ theme }) => theme.card};
  box-shadow: rgba(23, 92, 230, 0.15) 0px 4px 24px;
  
  border-radius: 16px;
  padding: 18px 36px;
  margin-bottom:20px;
  cursor:pointer;
  transition: transform 0.3s ease-in-out;
  &:hover {
    transform: scale(1.05) translateY(-10px);
    animation: float 1s infinite alternate;
  }
  @keyframes float {
    from {
      transform: scale(1.05) translateY(-10px);
    }
    to {
      transform: scale(1.05) translateY(-20px);
    }
  }
  @media (max-width: 768px) {
    max-width: 400px;
    padding: 10px 36px;
  }
  @media (max-width: 500px) {
    max-width: 330px;
    padding: 10px 36px;
  }
`;

const SkillTitle = styled.h2`
  font-size: 28px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 20px;
  text-align: center;
`;

const SkillList = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 20px;
`;

// border: 1px solid ${({ theme }) => theme.text_primary + 80};
const SkillItem = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.text_primary + 80};
  
  border-radius: 12px;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 8px 12px;
  }
  @media (max-width: 500px) {
    font-size: 14px;
    padding: 6px 12px;
  }
`;

const SkillImage = styled.img`
  width: 20em;
  border-radius : 1em;
  
`;
// height: 15em;

const Skills = () => {
  return (
    <Container id="skills">
      <Wrapper>
        <Title>Our Sponsors</Title>
        {/* <Desc style={{marginBottom:"20px"}}>Here are some of my skills.</Desc> */}
        <SkillsContainer>
          {Sponsors.map((Sponsor) => (
            <Skill key={Sponsor.title}>
              <SkillTitle>{Sponsor.title}</SkillTitle>
              <SkillList>
                {Sponsor.Sponsor.map((item) => (
                  <SkillItem key={item.name}>
                    <SkillImage src={item.image} />
                    {item.name}
                  </SkillItem>
                ))}
              </SkillList>
            </Skill>
          ))}
        </SkillsContainer>
      </Wrapper>
    </Container>
  );
};

export default Skills;
